module.exports = __webpack_public_path__ + "img/icon_check_grey.868fb504.svg";